import React from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import {makeStyles, Table, TableBody, TableHead, TableRow} from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import _ from 'lodash';
import {useTranslation} from "react-i18next";
import styled from "styled-components";

const useStyles = makeStyles(theme => ({
   root: {
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: '1rem 2rem',
      overflowY: 'scroll',
   },
   answer: {
      margin: '0 0 2rem 0 !important',
   },
   quota: {
      margin: '0 !important',
      marginTop: '1rem !important'
   },
   quotaTitle: {
      backgroundImage: 'none',
      backgroundColor: '#347EA3',
      minHeight: '55px !important',
      display: 'flex'
   },
   quotaTitleText: {
      color: '#ffffff',
      padding: '0 !important',
      fontSize: theme.typography.pxToRem(21)
   },
   quotaTitleDesc: {
      fontSize: theme.typography.pxToRem(10),
      color: '#FFFFFF',
      paddingLeft: '1rem'
   },
   quotaHeader: {
      backgroundColor: '#E1E7E9'
   }
}));

function QuotaCell(props) {
   const { t } = useTranslation();

   return props.cells.map(cell => {
      let targetSamples = '-';
      let remainingSamples = '-';
      if (cell.num_target_samples) {
         targetSamples = cell.num_target_samples;
         remainingSamples = cell.num_target_samples - cell.num_collected_samples;
      }

      let status = t('quota_status_0');
      if (cell.num_target_samples) {
         status = cell.num_target_samples - cell.num_collected_samples <= 0 ? t('quota_status_1') : t('quota_status_0')
      }

      return (<TableRow key={cell.quota_cell_id}>
         <TableCell>{cell.priority_level}</TableCell>
         <TableCell>{cell.quota_cell_name}</TableCell>
         <TableCell>{targetSamples}</TableCell>
         <TableCell>{cell.num_collected_samples}</TableCell>
         <TableCell>{remainingSamples}</TableCell>
         <TableCell>{status}</TableCell>
      </TableRow>)
      })
};

function QuotaComponent(props) {
   const classes = useStyles();
   const { t } = useTranslation();
   let quotaName = '';
   let quotaType = '';
   if (props.quota.quota_param === 'quota1') {
      if (props.quota.quota_type == 3 || props.quota.quota_type == 2) {
         quotaName = t('quota_type_23');
      } else {
         quotaName = t('quota_type_1');
      }
      quotaName = t('title_quota') + '1 ' + quotaName;
   } else if (props.quota.quota_param === 'quota2') {
      if (props.quota.quota_type == 3 || props.quota.quota_type == 2) {
         quotaName = t('quota_type_23');
      } else {
         quotaName = t('quota_type_1');
      }
      quotaName = t('title_quota') + '2 ' + quotaName;
   } else if (props.quota.quota_param === 'quota3') {
      if (props.quota.quota_type == 3 || props.quota.quota_type == 2) {
         quotaName = t('quota_type_23');
      } else {
         quotaName = t('quota_type_1');
      }
      quotaName = t('title_quota') + '3 ' + quotaName;
   }
   let cellRows = <QuotaCell cells={props.quota.cells} key={props.quota.quota_table_id}/>;

   return (
      <ExpansionPanel className={classes.quota} expanded={true}>
         <ExpansionPanelSummary
            className={classes.quotaTitle}
            style={{cursor: 'initial'}}>
            <Typography className={classes.quotaTitleText}>{quotaName}</Typography>
            <div>
               <Typography className={classes.quotaTitleDesc}>{t('title_quota_desc1')}</Typography>
               <Typography className={classes.quotaTitleDesc}>{t('title_quota_desc2')}</Typography>
            </div>
         </ExpansionPanelSummary>
         <ExpansionPanelDetails style={{padding: 0}}>
            <Table size="small">
               <TableHead className={classes.quotaHeader}>
                  <TableRow>
                     <TableCell>{t('quota_headers_0')}</TableCell>
                     <TableCell>{t('quota_headers_1')}</TableCell>
                     <TableCell>{t('quota_headers_3')}</TableCell>
                     <TableCell>{t('quota_headers_4')}</TableCell>
                     <TableCell>{t('quota_headers_5')}</TableCell>
                     <TableCell>{t('quota_headers_6')}</TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  {
                     cellRows
                  }
               </TableBody>
            </Table>
         </ExpansionPanelDetails>
      </ExpansionPanel>
   )
}

function QuotaList(props) {
   return props.quota.map(quota => <QuotaComponent key={quota.quota_param}
                                                   quota={quota}></QuotaComponent>);
}

function Answer(props) {
   const { t } = useTranslation();
   if (('all_answer_count' in props.survey) && props.survey.all_answer_count >= 0) {
      return (<TableRow>
         <TableCell>{t('label_gt').replace('{id}', props.surveyNo)}</TableCell>
         <TableCell>{props.survey.all_answer_count}</TableCell>
         <TableCell>{props.survey.all_question_answer_count}</TableCell>
      </TableRow>)
   }
   return (<TableRow>
   </TableRow>)
}

function Answers(props) {
   const classes = useStyles();
   const { t } = useTranslation();
   let surveys = _.filter(props.surveys, function(s) { return (('all_answer_count' in s) && s.all_answer_count >= 0) });
   let answers = surveys.map((s, i) => <Answer key={i} survey={s} surveyNo={_.indexOf(props.surveys, s) + 1}/>);
   let count = surveys.length;
   if (count === 0) return <div></div>;
   return (
      <ExpansionPanel className={classes.answer} expanded={true}>
         <ExpansionPanelSummary
            className={classes.quotaTitle}
            style={{cursor: 'initial'}}>
            <Typography className={classes.quotaTitleText}>{t('title_answer')}</Typography>
         </ExpansionPanelSummary>
         <ExpansionPanelDetails style={{padding: 0}}>
            <Table size="small">
               <TableHead className={classes.quotaHeader}>
                  <TableRow>
                     <TableCell>{t('answer_headers_0')}</TableCell>
                     <TableCell>{t('answer_headers_1')}</TableCell>
                     <TableCell>{t('answer_headers_2')}</TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  {answers}
               </TableBody>
            </Table>
         </ExpansionPanelDetails>
      </ExpansionPanel>
   )
}

let Root  = styled.div`
   height: calc(100vh - 3rem);
`;

function Quota(props) {
   const classes = useStyles();
   const { t } = useTranslation();
   return (
      <Root className={classes.root} >
         <div style={{display: 'flex', flexDirection: 'row-reverse', marginTop: '1rem'}}>
            <span>{t('updated_at')}{props.updatedAt}</span>
         </div>
         <Answers {...props} />
         <QuotaList {...props} />
      </Root>
   )
}

export default Quota